import {h, Fragment} from "preact"
import Product from "./Product"
import { useAppState } from "@nosto/preact"
import { useEffect } from "preact/hooks"

export default function Products() {
    const {
        response: { products },
        loading,
        query,
        pageType 
    } = useAppState()

    useEffect(()=>{
        if(typeof window.StampedFn?.reloadUGC === 'function') {
            window.StampedFn.reloadUGC();
        }   
    })

    useEffect(()=>{
        if(pageType === "search"){
            const nativeQuantityElement = document.querySelector("#ProductCountDesktop");
            if(nativeQuantityElement){
                nativeQuantityElement.textContent = `Showing ${products?.total} results for "${query?.query}"`;
            }
        }

    }, [products])

    return (
        <ul id="product-grid" class="grid product-grid grid--2-col-tablet-down grid--3-col-desktop ns-product-grid" 
        // style={loading ? "opacity: 0.3;" : ""}
        // data-id="template--15680832340073__product-grid"
        >
            {products.hits.map((hit, index) => {
                return <Product product={hit} key={hit.productId || index} index={index} />
            })}
        </ul>
    )
}
